import { nanoid } from "nanoid";

/**
 * Return a random id with a length of 10
 * @returns {string} random id 10 Char length
 */
export const RandomId = (): string => nanoid(10);

